// Basic Functions

document.addEventListener("touchstart", function(){}, true);

$(document).ready(function(){
  
  // roundedTeaser
	var roundedTeaser = function () {
    $('.rounded-background').each(function () {
      var roundedHeight = $(this).outerHeight();
      var roundedWidth = $(this).outerWidth();
  		if (roundedHeight > roundedWidth || $(window).width() < 992) {
        $(this).removeClass('rounded-active');
        $(this).css('border-top-right-radius', 0);
        $(this).css('border-bottom-right-radius', 0);
  		} else {
        $(this).addClass('rounded-active');
        $(this).css('border-top-right-radius', roundedHeight/2);
        $(this).css('border-bottom-right-radius', roundedHeight/2);
  		}
    });
	};
  roundedTeaser();
	$(window).resize(function() {
    roundedTeaser();
	});
  
	// ##############################################
	// ################## fancybox ##################
	// ##############################################  
  
  $('.giz-fancybox-inline').on('click', function(e) {
    
    e.preventDefault();
    var target = this.hash;
    //console.log( target+' loaded!' );
    
    $.fancybox.open({
      //parentEl : 'body',
      //animationEffect : "zoom",
    	src  : target,
    	type : 'inline',
      modal : 'true',
      clickSlide : 'false',
      touch: false,
    	opts : {
    		afterShow : function( instance, current ) {
      		//console.info( instance );
      		//console.info( current['src'] );
          var currentID = current['src'];
          
          if ($(currentID).hasClass('fancybox-fullscreen')) {
            var closeButton = $(currentID).find('.fancybox-close-small');
            $(closeButton).addClass('fancybox-fullscreen-close');
            $('body').append(closeButton);
          }
          
          $(currentID).find('.slick-slider').slick('refresh');

          $('.fancybox-fullscreen-close').click(function(){
            $.fancybox.close();
            //$(this).hide();    
          });
          
    		},
        beforeClose :  function( instance, current ) {
          $('.fancybox-fullscreen-close').hide();
        }
    	}
    });
    
  });
  
  $('.image-fancybox').on('click', function (e) {
    e.preventDefault();
    var target = this.href;
    //console.info(target);
    $.fancybox.open({
      src: target,
      type: 'image',
      opts: {
        buttons: [
        //"zoom",
        //"share",
        //"slideShow",
        //"fullScreen",
        "download",
        //"thumbs",
        "close"],
        afterShow: function afterShow(instance, current) {
          //console.info( 'done!' );
        }
      }
    });
  });
  
  $('.product-image-fancybox').on('click', function (e) {
    e.preventDefault();
    var target = this.href;
    //console.info(target);
    $.fancybox.open({
      src: target,
      type: 'image',
      opts: {
        baseTpl:
          '<div class="fancybox-container fancybox-container-product-image" role="dialog" tabindex="-1">' +
          '<div class="fancybox-bg"></div>' +
          '<div class="fancybox-inner">' +
          '<div class="fancybox-infobar">' +
          "<span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span>" +
          "</div>" +
          '<div class="fancybox-toolbar">{{buttons}}</div>' +
          '<div class="fancybox-navigation">{{arrows}}</div>' +
          '<div class="fancybox-stage"></div>' +
          '<div class="fancybox-caption"></div>' +
          "</div>" +
          "</div>",
        buttons: [
        //"zoom",
        //"share",
        //"slideShow",
        //"fullScreen",
        "download",
        //"thumbs",
        "close"],
        afterShow: function afterShow(instance, current) {
          //console.info( 'done!' );
        }
      }
    });
  });

  $().fancybox({
    selector: '.story-slider .tile-image-fancybox',
    backFocus: false,
    //thumbs: {
    //  autoStart : true
    //},
    preventCaptionOverlap: true,
    arrows: true,
    infobar: false,
    buttons: [
      //"zoom",
      //"share",
      //"slideShow",
      //"fullScreen",
      "download",
      //"thumbs",
      "close"],
    // Läuft leider nicht im infinite-mode.
    //afterShow: function (instance, current) {
    //  current.opts.$orig.closest(".slick-initialized").slick('slickGoTo', parseInt(current.index), true);
    //}
  });
  
  
	// ##############################################
	// ############### Scroll to top ################
	// ##############################################  

	$('.scrollToTop').click(function(){
		$('html, body').animate({scrollTop : 0}, 800);
		return false;
  });
  

  // ##############################################
	// ############### Match Height #################
	// ##############################################  

  $('.news-home-tile .card-title').matchHeight();

      
});


// WEBPACK FOOTER //
// ./js/parts/base.js